/**
 * @generated SignedSource<<d3f89ff8d874d285cf9e4e12a48c2c8f>>
 * @relayHash 8a5f88c31eae893c420fe6862fbb6c53
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID f77347333701fe87bd5d5826802613eb72156f033169fd478f3327314f14b9c3

import type { ConcreteRequest, Query } from 'relay-runtime';
export type AccountMenuTrashedPersonalSpacesQuery$variables = {
  creatorAccountIds?: ReadonlyArray<string> | null | undefined;
};
export type AccountMenuTrashedPersonalSpacesQuery$data = {
  readonly spaces: {
    readonly nodes: ReadonlyArray<{
      readonly alias: string | null | undefined;
      readonly id: string | null | undefined;
      readonly key: string | null | undefined;
    } | null | undefined> | null | undefined;
  } | null | undefined;
};
export type AccountMenuTrashedPersonalSpacesQuery = {
  response: AccountMenuTrashedPersonalSpacesQuery$data;
  variables: AccountMenuTrashedPersonalSpacesQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "creatorAccountIds"
  }
],
v1 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "creatorAccountIds",
        "variableName": "creatorAccountIds"
      },
      {
        "kind": "Literal",
        "name": "status",
        "value": "TRASHED"
      },
      {
        "kind": "Literal",
        "name": "type",
        "value": "PERSONAL"
      }
    ],
    "concreteType": "PaginatedSpaceList",
    "kind": "LinkedField",
    "name": "spaces",
    "plural": false,
    "selections": [
      {
        "concreteType": "Space",
        "kind": "LinkedField",
        "name": "nodes",
        "plural": true,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "alias"
          },
          {
            "kind": "ScalarField",
            "name": "key"
          },
          {
            "kind": "ScalarField",
            "name": "id"
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "AccountMenuTrashedPersonalSpacesQuery",
    "selections": (v1/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "AccountMenuTrashedPersonalSpacesQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "8a5f88c31eae893c420fe6862fbb6c53",
    "id": "f77347333701fe87bd5d5826802613eb72156f033169fd478f3327314f14b9c3",
    "metadata": {},
    "name": "AccountMenuTrashedPersonalSpacesQuery",
    "operationKind": "query",
    "text": "query AccountMenuTrashedPersonalSpacesQuery($creatorAccountIds:[String!]){spaces(type:\"PERSONAL\",creatorAccountIds:$creatorAccountIds,status:\"TRASHED\"){nodes{alias,key,id}}}"
  }
};
})();

(node as any).hash = "441235242490f35c2f56b55ed716011d";

export default node;
